import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StickyHeader } from '@components/molecules/StickyHeader/StickyHeader';
import { Carousel, CarouselProps } from '@components/molecules/Carousel';
import { ServicesHighlights, ServicesHighlightsProps } from '@components/molecules/ServicesHighlights';
import { Maps } from '@components/molecules/Maps';
import { Footer } from '@components/molecules/Footer';
import { MarketplaceAdvertising } from '@components/molecules/MarketplaceAdvertising';
import { Space } from '@components/atoms/Space';
import { useData } from '@hooks/useData';
import { useGetAllSettings } from '@services/useGetAllSettings';

export interface HomeProps {
    carouselItems: CarouselProps['items'];
    services: ServicesHighlightsProps['services'];
}

export const Home: FC<HomeProps> = ({ carouselItems, services }) => {
    const { allSettings } = useData();
    const { t, i18n } = useTranslation();
    const { request: requestAllSettings } = useGetAllSettings();
    
    useEffect(() => {
        requestAllSettings();
    }, [i18n.language]);

    const translations = {
        servicesActionLabel: t('home-component.services.action.label'),
    };

    return (
        <>
            <StickyHeader />

            <Carousel items={carouselItems} mode="wide" includeLogos={allSettings?.data?.isFinanced || false} />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <Maps />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <ServicesHighlights
                overline={allSettings?.data?.content_homepage_featured_stores_section_label}
                title={allSettings?.data?.content_homepage_featured_stores_title || ''}
                description={allSettings?.data?.content_homepage_featured_stores_subtitle}
                actionLabel={translations.servicesActionLabel}
                linkTo="services"
                services={services}
            />

            <Space spaceBreakpoints={{ xs: { space: 50 }, md: { space: 100 } }} />

            <MarketplaceAdvertising />

            <Footer mode="normal" />
        </>
    );
};
